import { auth, Button, Subtitle1, Subtitle2, useAlert, userContext, useTheme } from "capsule"
import React, { useContext, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Pressable, StyleSheet, View } from "react-native"
import { Text } from "react-native-paper"

import { NeedEmailVerifiedNS } from "../../features/i18n/constants"
import { useMigrationAccount } from "../../features/Providers/MigrationAccountProvider"

const NeedEmailVerifiedScreen = () => {
  const { t } = useTranslation(NeedEmailVerifiedNS)
  const {
    dimensions: { spacing },
    colors: {
      surface: { background },
    },
  } = useTheme()
  const { logout, user } = useContext(userContext)
  const { showSnack } = useAlert()

  const { isMigrating } = useMigrationAccount()
  const { view } = useMemo(
    () => ({
      view: [styles.view, { backgroundColor: background, paddingHorizontal: spacing }],
    }),
    [spacing, background],
  )
  const handleValidation = async () => {
    await auth().currentUser?.reload()
    if (!auth().currentUser?.emailVerified) {
      showSnack(t("emailNotVerified"))
    }
  }
  const handleSendBack = async () => {
    await user?.sendEmailVerification()
    showSnack(t("emailSent"))
  }
  return (
    <View style={view}>
      <Subtitle1 style={styles.bold}>
        {t(isMigrating ? "migration.needEmailConfirm" : "needEmailConfirm")}
      </Subtitle1>
      <Subtitle2>{t("initialEmailSent")}</Subtitle2>
      <Button onPress={handleValidation}>{t("validation")}</Button>
      <Button onPress={logout}>{t("cancel")}</Button>
      <View style={styles.text}>
        <Text>{t("nothingReceived")}</Text>
        <Pressable onPress={handleSendBack}>
          <Text style={styles.link}>{t("sendBack")}</Text>
        </Pressable>
      </View>
    </View>
  )
}
const styles = StyleSheet.create({
  view: {
    flex: 1,
    display: "flex",
    gap: 16,
    paddingVertical: 20,
  },
  bold: {
    fontWeight: "bold",
  },
  text: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    gap: 4,
  },
  link: {
    color: "#00678A",
    fontWeight: "semibold",
  },
})
export default NeedEmailVerifiedScreen
